
import React, { useEffect, useState } from 'react'
import { Card, Row, Col, Form, Button, Modal } from 'react-bootstrap'
import DataTable from 'react-data-table-component'
import ControlContrasenasService from '../../../Services/Catalogos/CatSistemas'
import { MsgInformativo } from '../../../Utils/Toast/msgInformativo'
import { EmpleadoMasterDto } from './DTO/EmpleadoMasterDto'
import { ControlContrasena } from './DTO/DTOControlContrasena'
import { ActualizarContrasenaDto } from './DTO/DTOActualizarContrasena'


interface Props {
    numEmpleadoInicial?: string; // Para que cargue directo si viene del otro catálogo
} 


// const ControlContrasenas: React.FC = () => {

const ControlContrasenas: React.FC<Props> = ({ numEmpleadoInicial }) => {

    const [empleados, setEmpleados] = useState<EmpleadoMasterDto[]>([])
    const [empleadosFiltrados, setEmpleadosFiltrados] = useState<EmpleadoMasterDto[]>([])
    const [contrasenas, setContrasenas] = useState<ControlContrasena[]>([])
    const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState<string>("")
    const [filtro, setFiltro] = useState("")

    const [showMsg, setShowMsg] = useState(false)
    const [msg, setMsg] = useState("")
    const [header, setHeader] = useState("")

    const [showModal, setShowModal] = useState(false)
    const [tipoContrasena, setTipoContrasena] = useState("")
    const [nuevaContrasena, setNuevaContrasena] = useState("")
    const [modoEditar, setModoEditar] = useState(false)

    const [mostrarPasswords, setMostrarPasswords] = useState<{ [key: number]: boolean }>({})

    useEffect(() => {
        cargarMaster()
    }, [])


    useEffect(() => {
        cargarMaster()
        if(numEmpleadoInicial) {
            cargarDetalle(numEmpleadoInicial) // Carga las llaves del empleado seleccionado
        }
    }, [numEmpleadoInicial])


    
    const cargarMaster = async () => {
        try {
            const response = await ControlContrasenasService.GetEmpleadosMaster()
            setEmpleados(response.data)
            setEmpleadosFiltrados(response.data)
        } catch {
            mostrarMensaje("Error", "Error al cargar empleados")
        }
    }

    const cargarDetalle = async (numEmpleado: string) => {
        try {
            const response = await ControlContrasenasService.GetByEmpleado(numEmpleado)
            setContrasenas(response.data)
            setEmpleadoSeleccionado(numEmpleado)
        } catch {
            mostrarMensaje("Error", "Error al cargar contraseñas")
        }
    }

    const mostrarMensaje = (titulo: string, mensaje: string) => {
        setHeader(titulo)
        setMsg(mensaje)
        setShowMsg(true)
    }

    const filtrar = (e: any) => {
        const value = e.target.value
        setFiltro(value)

        const filtrados = empleados.filter(emp =>
            emp.numEmpleado.toLowerCase().includes(value.toLowerCase()) ||
            emp.name.toLowerCase().includes(value.toLowerCase())
        )

        setEmpleadosFiltrados(filtrados)
    }

    const abrirModalInsert = () => {
        setModoEditar(false)
        setTipoContrasena("")
        setNuevaContrasena("")
        setShowModal(true)
    }

    const abrirModalEditar = (row: ControlContrasena) => {
        setModoEditar(true)
        setTipoContrasena(row.tipoContrasena)
        setNuevaContrasena("")
        setShowModal(true)
    }

    const guardarContrasena = async () => {

        if (!tipoContrasena || !nuevaContrasena) {
            mostrarMensaje("Advertencia", "Complete todos los campos")
            return
        }

        const data: ActualizarContrasenaDto = {
            numEmpleado: empleadoSeleccionado,
            tipoContrasena: tipoContrasena,
            contrasena: nuevaContrasena
        }

        try {
            await ControlContrasenasService.ActualizarContrasena(data)
            mostrarMensaje("Éxito", "Contraseña guardada correctamente")
            setShowModal(false)
            cargarDetalle(empleadoSeleccionado)
            await cargarMaster() 
        } catch {
            mostrarMensaje("Error", "Error al guardar contraseña")
        }
    }

    const eliminarContrasena = async (row: ControlContrasena) => {
        if (!window.confirm("¿Seguro que deseas eliminar esta contraseña?")) return

        try {
            await ControlContrasenasService.EliminarContrasena(
                row.numEmpleado,
                row.tipoContrasena
            )
            mostrarMensaje("Eliminado", "Contraseña eliminada correctamente")
            cargarDetalle(row.numEmpleado)
            await cargarMaster() 
        } catch {
            mostrarMensaje("Error", "Error al eliminar contraseña")
        }
    }

    const toggleMostrarPassword = (id: number) => {
        setMostrarPasswords(prev => ({
            ...prev,
            [id]: !prev[id]
        }))
    }

    const columnasMaster = [
        {
            name: "NumEmpleado",
            selector: (row: EmpleadoMasterDto) => row.numEmpleado,
            sortable: true,
            width: "120px"
        },
        {
            name: "Nombre",
            selector: (row: EmpleadoMasterDto) => row.name,
            sortable: true,
            wrap: true
        },
        {
            name: "Departamento",
            selector: (row: EmpleadoMasterDto) => row.departamento,
            sortable: true
        },
        {
            name: "Tiene Contraseñas",
            cell: (row: EmpleadoMasterDto) => (
                <span className={row.tieneContrasenas ? "badge bg-success" : "badge bg-secondary"}>
                    {row.tieneContrasenas ? "SI" : "NO"}
                </span>
            )
        }
    ]

    const columnasDetalle = [
        {
            name: "Tipo",
            selector: (row: ControlContrasena) => row.tipoContrasena,
            sortable: true
        },
        {
            name: "Contraseña",
            cell: (row: ControlContrasena) => (
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <span>
                        {mostrarPasswords[row.id]
                            ? row.contrasenaPlana
                            : "••••••••"}
                    </span>
                    <Button
                        size="sm"
                        variant="outline-secondary"
                        onClick={() => toggleMostrarPassword(row.id)}
                    >
                        👁
                    </Button>
                </div>
            )
        },
        {
            name: "FechaActualizacion",
            selector: (row: ControlContrasena) =>
            (row.fechaUltimaActualizacion), 
            width: "180px"
        },
        {
            name: "Vencimiento",
            selector: (row: ControlContrasena) =>(row.fechaVencimiento), 
            width: "180px"
        },
        {
            name: "Estatus",
            cell: (row: ControlContrasena) => (
                <span className={
                    row.estatus === "AL DIA"
                        ? "badge bg-success"
                        : row.estatus === "POR VENCER"
                        ? "badge bg-warning"
                        : "badge bg-danger"
                }>
                    {row.estatus}
                </span>
            )
        },
        {
            name: "FechaRegistro",
            selector: (row: ControlContrasena) =>
                (row.fechaRegistroSistema)
           
        },
        {
            name: "Acciones",
            cell: (row: ControlContrasena) => (
                <div style={{ display: 'flex', gap: '5px' }}>
                    <Button
                        size="sm"
                        variant="primary"
                        onClick={() => abrirModalEditar(row)}
                    >
                        Editar
                    </Button>

                    <Button
                        size="sm"
                        variant="danger"
                        onClick={() => eliminarContrasena(row)}
                    >
                        Eliminar
                    </Button>
                </div>
            )
        }
    ]

    return (
        <div className="container-fluid mt-3">

            <Row>
                <Col md={6}>
                    <Card>
                        <Card.Body>
                            <h5>Empleados</h5>

                            <Form.Control
                                type="text"
                                placeholder="Buscar..."
                                value={filtro}
                                onChange={filtrar}
                                className="mb-3"
                            />

                            <DataTable
                                columns={columnasMaster}
                                data={empleadosFiltrados}
                                onRowClicked={(row: any) => cargarDetalle(row.numEmpleado)}
                                highlightOnHover
                                pointerOnHover
                                pagination
                                dense
                            />
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={6}>
                    <Card>
                        <Card.Body>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <h5>
                                    Contraseñas {empleadoSeleccionado && `- ${empleadoSeleccionado}`}
                                </h5>

                                {empleadoSeleccionado && (
                                    <Button size="sm" variant="success" onClick={abrirModalInsert}>
                                        + Nueva
                                    </Button>
                                )}
                            </div>

                            <DataTable
                                columns={columnasDetalle}
                                data={contrasenas}
                                pagination
                                highlightOnHover
                                dense
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* MODAL */}
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {modoEditar ? "Actualizar Contraseña" : "Nueva Contraseña"}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Tipo Contraseña</Form.Label>
                        <Form.Control
                            type="text"
                            value={tipoContrasena}
                            onChange={(e) => setTipoContrasena(e.target.value)}
                            disabled={modoEditar}
                        />
                    </Form.Group>

                    <Form.Group>
                        <Form.Label>Contraseña</Form.Label>
                        <Form.Control
                            type="password"
                            value={nuevaContrasena}
                            onChange={(e) => setNuevaContrasena(e.target.value)}
                        />
                    </Form.Group>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={guardarContrasena}>
                        Guardar
                    </Button>
                </Modal.Footer>
            </Modal>

            <MsgInformativo
                show={showMsg}
                msg={msg}
                header={header}
                msgColor="primary"
                closeToast={() => setShowMsg(false)}
            />
        </div>
    )
}

export default ControlContrasenas
